import type { SVGProps } from 'react';
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.429 4.857A.855.855 0 0 0 9.57 4a.855.855 0 0 0-.857.857v1.429H7.286A2.29 2.29 0 0 0 5 8.57V20a2.29 2.29 0 0 0 2.286 2.286h11.428A2.29 2.29 0 0 0 21 20V8.571a2.29 2.29 0 0 0-2.286-2.285h-1.428V4.857A.855.855 0 0 0 16.429 4a.855.855 0 0 0-.858.857v1.429H10.43zm-3.715 6h12.572V20a.573.573 0 0 1-.572.571H7.286A.573.573 0 0 1 6.714 20z"
    />
  </svg>
);
export default SvgCalendar;
